// UMD Australia — content data
export const SITE = {
  name: "UMD",
  fullName: "Unique Micro Design",
  tagline: "Engineering tomorrow's industry, since 1983.",
  phone: "+61 3 9582 7000",
  email: "enquiries@umd.com.au",
  address: "9 Beddoe Avenue, Bentleigh East, VIC 3165, Australia",
  abn: "ABN 50 007 419 462",
  socials: {
    linkedin: "https://linkedin.com/company/umd",
    youtube: "#",
    twitter: "#"
  }
};

export const HERO = {
  videoMp4: "https://customer-assets.emergentagent.com/job_umd-premium-redesign/artifacts/bal3w8dg_UMD_Corp_Vid.004.m4v",
  poster: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1920&q=80"
};

export const STATS = [
  { value: "40+", label: "Years engineering excellence", sub: "Since 1983" },
  { value: "1,200+", label: "Projects delivered nationally", sub: "Across 12 industries" },
  { value: "98%", label: "Client retention rate", sub: "Long-term partnerships" },
  { value: "24/7", label: "Engineering support", sub: "Australia-wide" }
];

export const SERVICES = [
  {
    slug: "engineering-iot",
    code: "01",
    title: "Engineering & IoT Solutions",
    short: "End-to-end design, prototyping and manufacturing of IoT devices, edge hardware and embedded systems.",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["Custom electronics design", "Edgeware & firmware", "PCB prototyping", "Sensor integration", "RFID & barcode systems", "Industrial gateways"]
  },
  {
    slug: "project-management",
    code: "02",
    title: "Technical Project Management",
    short: "End-to-end delivery of complex technology rollouts across construction, utilities, government and industrial environments.",
    icon: "Workflow",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["Project planning", "Vendor coordination", "Risk management", "Stakeholder reporting", "Nationwide deployment", "Quality assurance"]
  },
  {
    slug: "system-integration",
    code: "03",
    title: "System Integration & Deployment",
    short: "Integrate sensors, edge computing, networks and enterprise systems into a single source of operational truth.",
    icon: "Network",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["Industrial networking", "SCADA & MES integration", "Cloud connectors", "API engineering", "Data orchestration", "On-site commissioning"]
  },
  {
    slug: "manufacturing",
    code: "04",
    title: "Australian Manufacturing",
    short: "Locally manufactured electronics, enclosures and ruggedised hardware — built in Melbourne, deployed worldwide.",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["PCB assembly", "Cable harnesses", "Box-build", "Enclosure design", "Compliance testing", "Logistics & fulfilment"]
  },
  {
    slug: "technical-consulting",
    code: "05",
    title: "Technical Consulting",
    short: "Independent engineering advice for digital transformation, automation and asset performance programs.",
    icon: "Compass",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["Architecture review", "Technology selection", "Feasibility studies", "Standards & compliance", "OT/IT convergence", "Digital roadmaps"]
  },
  {
    slug: "asset-management",
    code: "06",
    title: "Asset & Lifecycle Management",
    short: "Full asset visibility and uptime guarantees through tracking, predictive maintenance and engineering support.",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?auto=format&fit=crop&w=1600&q=80",
    capabilities: ["RFID asset tracking", "Predictive maintenance", "Warranty & spares", "On-site engineering", "Performance dashboards", "End-of-life management"]
  }
];

export const INDUSTRIES = [
  { name: "Infrastructure", count: "180+ projects", image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80" },
  { name: "Government", count: "60+ agencies", image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1200&q=80" },
  { name: "Manufacturing", count: "240+ deployments", image: "https://images.unsplash.com/photo-1581091870622-2c0e2f8b7c2f?auto=format&fit=crop&w=1200&q=80" },
  { name: "Utilities & Energy", count: "Critical asset partner", image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=1200&q=80" },
  { name: "Transport & Logistics", count: "RFID at scale", image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=80" },
  { name: "Healthcare", count: "Compliance-first", image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&w=1200&q=80" },
  { name: "Education & Research", count: "University partnerships", image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1200&q=80" },
  { name: "Commercial & Retail", count: "Edge-to-cloud", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
  { name: "Defence & Aerospace", count: "Secure-by-design", image: "https://images.unsplash.com/photo-1517976487492-5750f3195933?auto=format&fit=crop&w=1200&q=80" }
];

export const PROJECTS = [
  {
    slug: "victoria-rail-iot",
    title: "Victorian Rail — Trackside IoT Network",
    category: "Infrastructure",
    location: "Melbourne, VIC",
    year: "2024",
    image: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?auto=format&fit=crop&w=1600&q=80",
    summary: "1,800 ruggedised edge nodes monitoring vibration, temperature and door cycles across the metropolitan rail network."
  },
  {
    slug: "national-warehouse-rfid",
    title: "National Logistics — Warehouse RFID Rollout",
    category: "Logistics",
    location: "Australia-wide",
    year: "2024",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80",
    summary: "Real-time asset visibility across 14 distribution centres, eliminating 92% of manual stock-take operations."
  },
  {
    slug: "smart-grid-utilities",
    title: "Smart Grid Sensor Platform",
    category: "Utilities",
    location: "Geelong, VIC",
    year: "2023",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1600&q=80",
    summary: "Edge analytics on 6,400 substation sensors reducing unplanned outages by 38% year-on-year."
  },
  {
    slug: "manufacturing-oee",
    title: "Heavy Manufacturing OEE Platform",
    category: "Manufacturing",
    location: "Dandenong, VIC",
    year: "2023",
    image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=1600&q=80",
    summary: "Real-time OEE visibility for a tier-one automotive supplier — 22% throughput uplift in nine months."
  },
  {
    slug: "hospital-asset-tracking",
    title: "Tertiary Hospital Asset Tracking",
    category: "Healthcare",
    location: "Sydney, NSW",
    year: "2022",
    image: "https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?auto=format&fit=crop&w=1600&q=80",
    summary: "BLE + RFID hybrid tracking across 1,100 critical care devices — 100% audit compliance achieved."
  },
  {
    slug: "defence-secure-gateway",
    title: "Defence Edge Gateway Program",
    category: "Defence",
    location: "Canberra, ACT",
    year: "2022",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1600&q=80",
    summary: "Hardened Australian-made gateways for restricted-network telemetry across multi-site facilities."
  },
  {
    slug: "port-container-tracking",
    title: "Port Container Identification",
    category: "Logistics",
    location: "Port Botany, NSW",
    year: "2021",
    image: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=1600&q=80",
    summary: "High-speed RFID portals reading container IDs at 60km/h with 99.97% accuracy."
  },
  {
    slug: "uni-smart-campus",
    title: "Smart Campus Sensor Network",
    category: "Education",
    location: "Clayton, VIC",
    year: "2021",
    image: "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=1600&q=80",
    summary: "4,200 environmental sensors integrated into the university BMS — 24% reduction in building energy."
  }
];

export const CASE_STUDIES = [
  {
    slug: "rail-iot",
    client: "Major Victorian Rail Operator",
    title: "How UMD delivered a trackside IoT network spanning 980km of metropolitan rail.",
    metric: "↓ 41% unplanned maintenance",
    image: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?auto=format&fit=crop&w=1600&q=80",
    problem: "Asset failures on critical rail segments were causing cascading service disruptions, with no real-time visibility of trackside equipment condition.",
    solution: "UMD designed and manufactured 1,800 ruggedised edge nodes, integrated with the operator's SCADA stack and a custom analytics dashboard.",
    result: "41% reduction in unplanned maintenance, 12-minute average response time, and a national rollout commenced in 2025."
  },
  {
    slug: "logistics-rfid",
    client: "Tier-1 National 3PL",
    title: "Real-time inventory visibility across 14 distribution centres.",
    metric: "↑ 99.9% stock accuracy",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80",
    problem: "Manual stock-takes were costing the client over $2.3M annually and creating customer service delays.",
    solution: "End-to-end RFID portals, handheld scanners and a unified WMS integration layer, deployed nationally over 14 months.",
    result: "92% reduction in manual cycle counts, 99.9% stock accuracy, and 4.5x ROI within 18 months."
  },
  {
    slug: "smart-grid",
    client: "Regional Utility Provider",
    title: "Smart-grid sensor platform reducing outage minutes by 38%.",
    metric: "↓ 38% outage minutes",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1600&q=80",
    problem: "Ageing substation infrastructure with no telemetry, leading to reactive maintenance and customer impact.",
    solution: "6,400 monitoring sensors with edge analytics, secure cellular backhaul and a predictive maintenance dashboard.",
    result: "38% fewer outage minutes year-on-year, $4.8M annual operating cost reduction, AS/NZS-certified rollout."
  }
];

export const TESTIMONIALS = [
  { quote: "UMD doesn't just deliver hardware — they become a part of your engineering team. Their problem-solving has changed how we operate.", name: "Sarah Whitman", role: "Director of Operations", company: "Tier-1 Logistics" },
  { quote: "After 12 years working with UMD, they remain the only Australian engineering partner I trust with mission-critical deployments.", name: "Dr. Anil Rao", role: "Head of Asset Strategy", company: "Public Utility" },
  { quote: "World-class technical depth, local manufacturing, and an absolutely uncompromising attitude towards quality. Exceptional partners.", name: "Marcus Chen", role: "CTO", company: "ASX-listed Manufacturer" }
];

export const CLIENTS = [
  "Monash University","Australia Post","BHP","Linfox","Toll Group","CSIRO","Coles","Bosch",
  "Bombardier","Defence Science","NBN Co","Honeywell","CityLink","Origin Energy","ANSTO","AGL"
];

export const TIMELINE = [
  { year: "1983", title: "UMD Founded", text: "Established in Melbourne as a specialist electronics engineering practice." },
  { year: "1992", title: "RFID Pioneer", text: "Among the first Australian companies to commercialise industrial RFID." },
  { year: "2004", title: "Manufacturing Expansion", text: "Opened our Bentleigh East advanced manufacturing facility." },
  { year: "2013", title: "Edgeware Platform", text: "Launched proprietary Edgeware IoT framework now powering 1,000+ deployments." },
  { year: "2019", title: "National Field Services", text: "Rolled out 24/7 engineering support across all Australian capital cities." },
  { year: "2024", title: "Industry 5.0", text: "Recognised as a Select Industrial Automation Partner with leading global OEMs." }
];

export const TEAM = [
  { name: "Geoff Sizer", role: "Founder & Chief Engineer", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=800&q=80" },
  { name: "Priya Anand", role: "Head of IoT Solutions", image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=80" },
  { name: "James O'Connell", role: "Director of Manufacturing", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=800&q=80" },
  { name: "Dr. Lin Zhou", role: "Principal Systems Architect", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80" },
  { name: "Daniel Petrov", role: "Head of Project Delivery", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=800&q=80" },
  { name: "Aroha Williams", role: "Quality & Compliance Lead", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=800&q=80" }
];

export const POSTS = [
  { slug: "edge-vs-cloud-2025", category: "IoT", date: "Nov 2025", title: "Edge or Cloud? Re-thinking industrial data architecture for 2026.", image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80", excerpt: "Where computation belongs in critical Australian infrastructure — a field-tested framework." },
  { slug: "rfid-at-port-speed", category: "Case Notes", date: "Oct 2025", title: "Reading containers at 60km/h: lessons from Port Botany.", image: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=1200&q=80", excerpt: "High-velocity RFID in real-world Australian port environments." },
  { slug: "australian-manufacturing", category: "Insights", date: "Oct 2025", title: "Why we still manufacture in Melbourne — and why our clients still ask us to.", image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1200&q=80", excerpt: "Sovereign capability, supply resilience, and the case for local engineering." },
  { slug: "as-iso-compliance", category: "Safety", date: "Sep 2025", title: "Navigating AS/NZS 3000 + ISO 27001 for IoT deployments.", image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80", excerpt: "Compliance is not a slide — it's an engineering practice." },
  { slug: "ai-on-the-edge", category: "Innovation", date: "Aug 2025", title: "Running ML models on field hardware: what actually works.", image: "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=1200&q=80", excerpt: "Benchmarks, watt budgets, and deployment patterns from 18 months of trials." },
  { slug: "iiot-roi", category: "Strategy", date: "Aug 2025", title: "The honest IIoT ROI conversation Australian executives need to have.", image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80", excerpt: "Where ROI is real, where it's overstated, and how to model it." }
];

export const FAQS = [
  { q: "What industries does UMD specialise in?", a: "Infrastructure, government, manufacturing, utilities, transport & logistics, healthcare, education, commercial and defence — anywhere mission-critical engineering matters." },
  { q: "Do you manufacture in Australia?", a: "Yes. Our advanced electronics manufacturing facility is in Bentleigh East, Melbourne. Sovereign capability is core to UMD." },
  { q: "What certifications do you hold?", a: "We operate under ISO 9001 quality, ISO 27001 information security and AS/NZS electrical standards. Project-specific accreditations available on request." },
  { q: "Can you deploy nationally?", a: "Absolutely. Our field-services team has delivered into every Australian capital city and across remote regional sites." },
  { q: "Do you take on greenfield design work?", a: "Yes. From concept through to manufacture and lifecycle support — UMD is a true full-stack engineering partner." }
];
